import classNames from "classnames";
import { useNavigate } from "react-router";
import type { PersistedAppointment } from "schemas";
import {
  AppointmentCard,
  Card,
  DotMenu,
  type DotMenuLink,
  HeaderMain,
  Loader,
  SmallTextMain,
  flexStyles,
  iconStyles,
  paddingStyles,
  textStyles,
} from "ui";
import { useAppointments } from "../../store";
import { Button, HomeWrapper, SuperCard } from "../ui";

export function List() {
  const navigate = useNavigate();
  const { loading, appointments } = useAppointments();

  if (loading) {
    return <Loader />;
  }

  const handleAppointmentClick = (appointment: PersistedAppointment) => {
    navigate(`/appointments/${appointment.id}`);
  };

  const linksForAppointment = (appointment: PersistedAppointment): DotMenuLink[] => [
    {
      label: "Edit Details",
      onClick: () => navigate(`${appointment.id}`),
      iconType: "Edit",
    },
    {
      label: "Edit Schedule",
      onClick: () => navigate(`${appointment.id}/schedule`),
      iconType: "EditCalendar",
    },
    {
      label: "Edit Utilities",
      onClick: () => navigate(`${appointment.id}/utilities`),
      iconType: "Settings",
    },
    {
      label: "Edit Automations",
      onClick: () => navigate(`${appointment.id}/automation`),
      iconType: "Automations",
    },
    {
      label: "Preview",
      onClick: () => {
        window.open(appointment.url, "_blank");
      },
      iconType: "OpenInNew",
    },
  ];

  if (appointments.length === 0) {
    return (
      <Card
        className={classNames(
          flexStyles.vert125,
          flexStyles.alignCenter,
          paddingStyles.p125,
          textStyles.primary,
          iconStyles.primary,
        )}
      >
        <SmallTextMain>Add an appointment.</SmallTextMain>
        <Button to="new"> ADD APPOINTMENT</Button>
      </Card>
    );
  }

  return (
    <HomeWrapper>
      <HeaderMain>Your Appointments</HeaderMain>
      <div className={classNames(flexStyles.vert050, paddingStyles.pt125)}>
        {appointments.map((appointment) => (
          <SuperCard
            key={appointment.id}
            title={appointment.name}
            onClick={() => handleAppointmentClick(appointment)}
            right={<DotMenu links={linksForAppointment(appointment)} />}
          >
            <AppointmentCard
              label={appointment.formattedPrice ? `Schedule for ${appointment.formattedPrice}` : "Schedule"}
              image={appointment.image}
              disabled={true}
              header={appointment.name}
              description={appointment.description}
              tags={appointment.tags}
              onClick={async () => {}}
            />
          </SuperCard>
        ))}
      </div>
      <Button buttonType="secondary" to="new">
        ADD NEW APPOINTMENT
      </Button>
    </HomeWrapper>
  );
}
